export default __webpack_public_path__ + "static/media/linkedin_logo.4f79a781.svg";